export const incrementZoomLevel = (view, currentZ) => view.setZoom(currentZ + 1);

export const decrementZoomLevel = (view, currentZ) => view.setZoom(currentZ - 1);

export const getZoomLevel = (zoomScale, currentZ) => zoomScale[currentZ];

/** nativeTopLevel: the top tiled level is native (imported WSI), so digital zoom starts one level higher. */
const _topShift = (nativeTopLevel) => (nativeTopLevel ? 1 : 0);

export const getMaxZoomFor = (zoomLevels, digitalZoomStatus, nativeTopLevel = false) =>
	zoomLevels.length - (digitalZoomStatus ? 1 : 2) + _topShift(nativeTopLevel);

export const checkIfDigitalZoom = (zoomLevels, currentZ, nativeTopLevel = false) =>
	zoomLevels.length - 1 + _topShift(nativeTopLevel) === currentZ;

export const ifShowDigitalText = (zoomLevels, currentZ, digitalZoomStatus, nativeTopLevel = false) =>
	getMaxZoomFor(zoomLevels, digitalZoomStatus, nativeTopLevel) === currentZ;
